import Text from "../../Components/Text/Text";
import { ReactComponent as LeftTriangleSvg } from "../../assets/svgs/left-triangle.svg";
import Img1 from '../../assets/images/home/clarity-alignment.png'
import Img2 from '../../assets/images/home/risk-scoring.png'
import Img3 from '../../assets/images/home/roadmap.png'
import Img4 from '../../assets/images/home/decision.png'
import { useRef, useState, useEffect } from "react";
import { useWindowScroll } from "../../hooks/useWindowScroll";
import { Link } from "react-router-dom";

const dataList = [
  {
    src: Img1,
    title: 'Clarity Alignment',
    description: "Define success together, align stakeholders, and surface blind spots early.",
  },
  {
    src: Img2,
    title: 'Risk Scoring & Scenario Forecasting',
    description: "Score risks model outcomes, prepare for what could go wrong.",
  },
  {
    src: Img3,
    title: 'Structured Execution Planning',
    description: "Lock scope track signals adapt with control, not chaos.",
  },
  {
    src: Img4,
    title: 'Decision Tracking & Learning Loops',
    description: "Capture key decisions, learn faster, compound insight, every project",
  },
]

export function RenderContent ({ item, index, show }) {
  const [active, setActive] = useState(false);
  
  useEffect(() => {
    const time = show ? index * 200 : 0;
    const timeId = setTimeout(() => setActive(show), time);
    return () => clearTimeout(timeId);
  }, [show, index]);

  return (
    <div className="flex-1">
      <div>
        <img src={item.src} alt={item.title} className={`mb-10 max-lg:mb-6 transition-all duration-700 delay-100 ${
            active ? "" : "opacity-0 translate-y-96"
          }`} />
          <div className="relative">
            <span className={`w-5 h-5 bg-white rounded-full inline-block max-lg:visible transition-all duration-700 delay-150 ${
                active ? "" : "opacity-0 translate-y-96"
              }`} />
            <span className="absolute left-0 border-b border-dashed border-white w-full h-1/2 top-0 max-lg:visible lg:hidden md:max-md:top-[-4px] tablet:max-xl:top-[-2px] max-sm:top-[-2px]" />  
          </div>
        <Text type="h1" size="d3" className={`mb-6 font-bold min-h-[126px] max-sm:min-h-fit max-sm:max-w-full text-white max-w-[294px] mt-6 lg:mt-10 transition-all duration-700 delay-200 ${
            active ? "" : "opacity-0 translate-y-96"
          }`}>{item.title}</Text>
        <Text type="p" size="bodyXl" className={`text-white transition-all duration-700 delay-300 ${
            active ? "" : "opacity-0 translate-y-96"
          }`}>
          {item.description}
        </Text>
      </div>
    </div>
  )
}

export default function OurDeliverySection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <div 
      className="relative" 
      style={{
        background: "radial-gradient(circle, #8c2926, #6c1513)"
      }}
      ref={ref}
    >
      <LeftTriangleSvg className="transition-all absolute top-0 fill-white animate-raise-up w-full" />
      {/* <span className="absolute left-0 border-b border-dashed border-white w-full h-1/2 top-[32px] max-lg:invisible max-xl:top-0" /> */}
      <span className="absolute left-0 border-b border-dashed border-white w-full h-1/2 2xl:top-[33px] max-lg:invisible lg:top-[-32px] lg:max-xl:top-[0px] xl:top-[33px]" />
      <div className="py-[320px] max-md:py-[120px] mx-auto container px-4" >
        <Text 
          type="h1" 
          size="d5" 
          className={`mb-16 transition-all duration-700 text-white ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >Our Delivery Framework</Text>
        <Link to='https://agilelabs.com/how-we-work'>
          <Text 
            type="span" 
            className={`text-white text-xl relative after:content-[''] inline-block after:inline-block after:w-full after:h-[2px] after:bg-yellow-500 after:absolute after:-bottom-3 after:left-0 transition-all duration-700 ${
            show ? "" : "opacity-0 translate-y-96"
          }`}
          >
            Discover Our Approach
          </Text>
        </Link>
        <div className="mt-16 gap-10 max-sm:gap-20 grid max-sm:!grid-cols-1 max-lg:grid-cols-2 grid-cols-4">
          {
            dataList.map((item, index) => (<RenderContent key={index} item={item} show={show} />))
          }
        </div>
      </div>
    </div>
  );
}